import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { setSortAToZ, setSortZToA } from './../actions/actions';

class Sort extends Component {
  render() {
    return (
      <div className="sort">
        <label className="sort__title">Sort from</label>
        <Button className={`sort__a-to-z ${this.props.isSortAtoZ === true ? 'btn-info': ''}`} onClick={this.props.setSortAToZ}>A to Z</Button>
        <Button className={`sort__z-to-a ${this.props.isSortAtoZ === false ? 'btn-info': ''}`} onClick={this.props.setSortZToA}>Z to A</Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentState = state.environment_information;
  const isSortAtoZ = currentState.get('isSortAtoZ')

  return {
    isSortAtoZ
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSortAToZ: () => dispatch(setSortAToZ()),
    setSortZToA: () => dispatch(setSortZToA())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sort);


// WEBPACK FOOTER //
// ./src/components/Sort.js